export default __webpack_public_path__ + "static/media/notification-bell.caa7c115.svg";